import api from '../../api/b4';
export default {
    name: 'b4-request-demo',
    data: function () {
        return {
            sending: false,
            hideForm: false,
            dialog: false,
            contactInfo: {
                name: "",
                email: "",
                company: "",
                phone: "",
                message: ""
            }
        };
    },
    computed: {
        canSend: function () {
            return this.contactInfo.name
                && this.contactInfo.email
                && this.contactInfo.company
                && this.contactInfo.phone
                && this.contactInfo.message;
        }
    },
    methods: {
        requestDemo: function () {
            if (this.sending)
                return;
            this.sending = true;
            var self = this;
            api.requestDemo(this.contactInfo).then(function (response) {
                self.dialog = true;
                self.sending = false;
                $(".v-dialog").css({ overflow: 'hidden' });
                $(".v-card").css({ 'background-color': '#2f4052' });
            });
        }
    }
};
